import { Injectable } from "@angular/core";
import { MenuConfigService } from "dspx-core";
import { AppSelector, HeaderMenuToggleSelector, HeaderSelector } from "../constants/app-data.constants";

@Injectable({
  providedIn: 'root'
})
export class HeaderCustomisationService {

  constructor(
    private menuConfigService: MenuConfigService) {
  }

  // Ensure the menu functionality is disabled, i.e.:
  // - hide the "menu toggle link" (i.e. the link in the header that allows to toggle the menu visibility)
  // - hide the menu
  disableMenu(): void {

    const { isMenuVisible } = this.getMenuStatus();
    if (isMenuVisible) {
      this.toggleMenuVisibility();
    }

    this.setHeaderMenuToggleVisibility({ showHeaderMenuToggle: false });
  }

  // Ensure the menu functionality is enabled, i.e.:
  // - display the "menu toggle link" (i.e. the link in the header that allows to toggle the menu visibility)
  // - display the menu (only if it is supposed to be displayed by default)
  enableMenu(): void {

    this.setHeaderMenuToggleVisibility({ showHeaderMenuToggle: true });

    const { isMenuVisible, isMenuVisibleByDefault } = this.getMenuStatus();
    if (!isMenuVisible && isMenuVisibleByDefault) {
      this.toggleMenuVisibility();
    }
  }

  private getMenuStatus(): { isMenuVisible: boolean; isMenuVisibleByDefault: boolean } {
    return (this.menuConfigService.styleConfigService.layoutMode === 'overlay')
      ? { isMenuVisible: !!this.menuConfigService.overlayMenuActive, isMenuVisibleByDefault: false }
      : (this.menuConfigService.isDesktop())
        ? { isMenuVisible: !this.menuConfigService.staticMenuDesktopInactive, isMenuVisibleByDefault: true }
        : { isMenuVisible: !!this.menuConfigService.staticMenuMobileActive, isMenuVisibleByDefault: false };
  }

  private toggleMenuVisibility(): void {
    this.menuConfigService.onMenuButtonClick(new Event('click'));
  }

  private setHeaderMenuToggleVisibility(configuration: { showHeaderMenuToggle: boolean }): void {
    const headerMenuToggleHtmlElement = document.querySelector(`${AppSelector} ${HeaderSelector} ${HeaderMenuToggleSelector}`) as HTMLElement;
    if (headerMenuToggleHtmlElement) {
      headerMenuToggleHtmlElement.style['display'] = configuration?.showHeaderMenuToggle ? '' : 'none';
    }
  }
}
